import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {Button, Input, Label} from 'reactstrap';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import Select from 'react-select';
import {createManual, loadManualList, selectManual} from 'manuals/actions/manual';

@connect(state => ({
    manuals: state.manuals
}), dispatch => {
    return {
        createManual: (manual) => dispatch(createManual(manual)),
        loadManualList: (category) => dispatch(loadManualList(category)),
        selectManual: (manual) => dispatch(selectManual(manual)),
    };
})
export default class NewManual extends Component {

    state = {
        isOpen: false,
        category: [],
        name: '',
        data: '',
        uploading: false
    };

    constructor(props) {
        super(props);
        this.categoryList = this.props.manuals.categoryList.map(
            category => ({value: category.id, label: category.name})
        )
        this.state = {
            category: [this.categoryList[0].value],
        };
    }

    @autobind
    toggle() {
        this.setState({isOpen: !this.state.isOpen});
    }

    @autobind
    confirm() {
        const data = this.state.data
        data.append('name', this.state.name);
        this.state.category.map(
            category => {
                data.append('category', category)
            }
        )
        this.props.createManual(data)
        this.toggle()
    }

    @autobind
    changeFile(e) {
        const data = new FormData();
        data.append('filename', e.target.files[0]);
        this.setState({data, name: this.state.name || e.target.files[0].name});
    }

    @autobind
    changeCategory(categoryList) {
        this.setState({category: categoryList.map(c => c.value)})
    }

    render() {
        return (<Fragment>
            <Button color='primary' onClick={this.toggle}>Neue Betriebsanweisung erstellen</Button>
            <Dialog isOpen={this.state.isOpen} toggle={this.toggle} confirm={this.confirm}
                    title="Neue Betriebsanweisung erstellen">
                <Fragment>
                    {!this.state.uploading &&
                    <Fragment>
                        <Label>
                            Name
                        </Label>
                        <Input type="text" value={this.state.name}
                               onChange={e => this.setState({name: e.target.value})}/>
                        <Label>
                            Kategorie
                        </Label>
                        <Select
                            isMulti={true}
                            options={this.categoryList}
                            onChange={this.changeCategory}
                            defaultValue={this.categoryList[0]}
                        />
                        <Label>
                            Vorlage
                        </Label>
                        <Input type="file" onChange={this.changeFile}/>
                    </Fragment>}
                    {this.state.uploading && <Loading/>}
                </Fragment>
            </Dialog>
        </Fragment>);
    }
}
